module.exports = __webpack_public_path__ + "images/traditional-2-fce36c536826b665ed78b48730b8f68d.jpg";